var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-sidebar-groups" },
    [
      _c("ChatGroupModeTabs", {
        staticClass: "mb-2",
        attrs: { modos: _vm.modos, "modo-ativo": _vm.modoAtivo },
        on: { change: _vm.selecionarModo }
      }),
      _vm.mostraCarregando
        ? _c(
            "div",
            { staticClass: "chat-sidebar-groups__esqueleto" },
            _vm._l(_vm.esqueletoGrupos, function(linha) {
              return _c(
                "div",
                {
                  key: linha.chave,
                  staticClass: "chat-sidebar-groups__esqueleto-linha"
                },
                [
                  _c(
                    "div",
                    { staticClass: "chat-sidebar-groups__esqueleto-titulo" },
                    [
                      _c("BaseLoadingSkeleton", {
                        attrs: { width: linha.titulo, height: "12px" }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _vm.mostraErro
        ? _c(
            "div",
            { staticClass: "ia-sidebar-aux chat-sidebar-groups__aviso" },
            [
              _c("div", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.texto.erro))
              ]),
              _c(
                "BaseButton",
                {
                  attrs: { underlined: "", "min-width": "80px" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("retry")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.texto.tentarDeNovo) + " ")]
              )
            ],
            1
          )
        : [
            _vm.semGrupos
              ? _c(
                  "div",
                  { staticClass: "ia-sidebar-aux chat-sidebar-groups__aviso" },
                  [_vm._v(" " + _vm._s(_vm.texto.semGrupos) + " ")]
                )
              : _vm._e(),
            _vm._l(_vm.grupos, function(grupo) {
              return _c(
                "div",
                {
                  key: grupo.chave,
                  staticClass: "chat-sidebar-groups__grupo",
                  class: {
                    "chat-sidebar-groups__grupo--drag-over":
                      grupo.chave === _vm.chaveDragOver
                  },
                  on: {
                    dragover: function($event) {
                      return _vm.onDragOver(grupo, $event)
                    },
                    dragleave: _vm.onDragLeave,
                    drop: function($event) {
                      return _vm.onDrop(grupo, $event)
                    }
                  }
                },
                [
                  grupo.folder
                    ? [
                        _c("FolderItem", {
                          attrs: {
                            folder: grupo.folder,
                            count: grupo.itens.length,
                            expanded: grupo.aberto
                          },
                          on: {
                            toggle: function($event) {
                              return _vm.alternarGrupo(grupo.chave)
                            },
                            rename: _vm.abrirRenomearPasta,
                            delete: _vm.confirmarExcluirPasta,
                            "drop-conversation": function($event) {
                              return _vm.$emit("move", $event)
                            }
                          }
                        }),
                        grupo.excluindo
                          ? _c("v-progress-linear", {
                              staticClass: "ia-sidebar-progresso",
                              attrs: { indeterminate: "", height: "2" }
                            })
                          : _vm._e(),
                        grupo.aberto
                          ? _c(
                              "div",
                              { staticClass: "chat-sidebar-groups__corpo" },
                              [
                                _vm._l(grupo.linhas, function(linha) {
                                  return _c("ConversationRow", {
                                    key: linha.conversa.id,
                                    attrs: {
                                      conversation: linha.conversa,
                                      selected:
                                        linha.conversa.id === _vm.selectedId,
                                      folders: _vm.pastas,
                                      "rotulo-secundario": linha.rotulo
                                    },
                                    on: {
                                      select: function($event) {
                                        return _vm.$emit("select", $event)
                                      },
                                      rename: function($event) {
                                        return _vm.$emit("rename", $event)
                                      },
                                      "request-delete": function($event) {
                                        return _vm.$emit(
                                          "request-delete",
                                          $event
                                        )
                                      },
                                      move: function($event) {
                                        return _vm.$emit("move", $event)
                                      }
                                    }
                                  })
                                }),
                                !grupo.itens.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ia-sidebar-aux chat-sidebar-groups__aviso"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.texto.pastaVazia) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    : _c(
                        "ChatSidebarGroup",
                        {
                          attrs: {
                            titulo: grupo.titulo,
                            "icon-name": grupo.iconName,
                            contador: grupo.itens.length,
                            aberto: grupo.aberto
                          },
                          on: {
                            toggle: function($event) {
                              return _vm.alternarGrupo(grupo.chave)
                            }
                          }
                        },
                        _vm._l(grupo.linhas, function(linha) {
                          return _c("ConversationRow", {
                            key: linha.conversa.id,
                            attrs: {
                              conversation: linha.conversa,
                              selected: linha.conversa.id === _vm.selectedId,
                              folders: _vm.pastas,
                              "rotulo-secundario": linha.rotulo
                            },
                            on: {
                              select: function($event) {
                                return _vm.$emit("select", $event)
                              },
                              rename: function($event) {
                                return _vm.$emit("rename", $event)
                              },
                              "request-delete": function($event) {
                                return _vm.$emit("request-delete", $event)
                              },
                              move: function($event) {
                                return _vm.$emit("move", $event)
                              }
                            }
                          })
                        }),
                        1
                      )
                ],
                2
              )
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }